import { I18n } from '@app/i18n/strings-keys';
import {
  COMMON_ACTION_TYPES,
  COMMON_ACTION_TYPES_REJECT,
} from '@app/shared/types/common/common-actions';

export const ACTION_OPERATE_MSG_PARAMS_MAPPING: Record<
  string,
  {
    did: string;
    lowerCasedDid: string;
    wantTo: string;
  }
> = {
  [COMMON_ACTION_TYPES.Submit]: {
    did: I18n.Status.Submitted,
    lowerCasedDid: I18n.Status.submitted,
    wantTo: I18n.Common.submit,
  },
  [COMMON_ACTION_TYPES.Cancel]: {
    did: I18n.Status.Canceled,
    lowerCasedDid: I18n.Status.canceled,
    wantTo: I18n.Common.cancel,
  },
  [COMMON_ACTION_TYPES.Accept]: {
    did: I18n.Status.Accepted,
    lowerCasedDid: I18n.Status.accepted,
    wantTo: I18n.Common.accept,
  },
  [COMMON_ACTION_TYPES_REJECT]: {
    did: I18n.Status.Rejected,
    lowerCasedDid: I18n.Status.rejected,
    wantTo: I18n.Common.reject,
  },
};
